import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqItems, companyInfo } from '../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-slate-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-1/3 h-full bg-gradient-to-r from-blue-50 to-transparent"></div>
      <div 
        className="absolute left-0 top-1/2 -translate-y-1/2 w-64 h-64 opacity-[0.03]"
        style={{
          backgroundImage: `url(${companyInfo.logo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left - Header */}
          <div className="lg:sticky lg:top-32">
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
              Întrebașri Frecvente
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Ai întrebări?
              <span className="text-gradient block">Noi avem răspunsuri</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Găsește răspunsurile la cele mai frecvente întrebări despre serviciile noastre de hidroizolație.
            </p>
            <div className="p-6 bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100">
              <h4 className="font-bold text-slate-900 mb-2">Nu ai găsit răspunsul?</h4>
              <p className="text-slate-600 text-sm mb-4">
                Contactează-ne direct și îți răspundem în cel mai scurt timp.
              </p>
              <a
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-cyan-600 transition-colors"
              >
                Sună la {companyInfo.phone}
              </a>
            </div>
          </div>

          {/* Right - Accordion */}
          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-white rounded-2xl shadow-md shadow-slate-200/50 border border-slate-100 px-6 overflow-hidden data-[state=open]:shadow-lg data-[state=open]:shadow-blue-500/10 data-[state=open]:border-blue-200 transition-all duration-300"
                >
                  <AccordionTrigger className="py-5 text-left hover:no-underline group">
                    <span className="text-lg font-semibold text-slate-900 group-hover:text-blue-600 transition-colors pr-4">
                      {item.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-slate-600 leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
